import React, { forwardRef, useEffect } from 'react';

export const Checkbox = forwardRef<HTMLInputElement, { indeterminate?: boolean | undefined }>(({ indeterminate, ...rest }, ref) => {
    const resolvedRef = ref;

    useEffect(() => {
        if (resolvedRef && resolvedRef != null && typeof resolvedRef !== 'function' && resolvedRef.current && indeterminate != undefined)
            resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
        <div className='form-check'>
            <input
                className='form-check-input'
                type='checkbox'
                ref={resolvedRef}
                {...rest}
            />
        </div>
    );
});

Checkbox.displayName = 'Search';
